import { render, staticRenderFns } from "./StockSelect.vue?vue&type=template&id=c0388e2e&scoped=true"
import script from "./StockSelect.vue?vue&type=script&lang=js"
export * from "./StockSelect.vue?vue&type=script&lang=js"
import style0 from "./StockSelect.vue?vue&type=style&index=0&id=c0388e2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0388e2e",
  null
  
)

export default component.exports